import { useState, useEffect } from 'react';
import { default as Tabs, type TabsProps } from 'antd/es/tabs';

import { loadXml } from '../utils/loadXml';
import { Resource } from '../components/Resource';
import { PrismCode } from '../components/PrismCode';
import { EndpointPath } from '../components/EndpointPath';
import { default as Skeleton } from 'antd/es/skeleton';
import { CUSTOM_TAB_STYLE } from '../useCustomAntdTheme';

export function IsoPage() {
  const [tabs, setTabs] = useState<TabsProps['items']>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadTabs = async () => {
      // This looks in the public directory
      // Unfortunately setting the dataSec in the CodeWrapper to point to a different will not work with tabs
      // I still don't know the reason why it doesn't want to rerender, but it seems to only draw the code once.
      // The only way to force it to do draw again is to load the xml file manually and then pass it like this here
      // The same will apply with code snippets, we will be able to generalize this component even further at a later stage

      const newTabs = [
        {
          key: 'received',
          label: 'Received',
          children: (
            <PrismCode
              showClipboard
              language="xml"
              code={(await loadXml('iso2022-received-response')) ?? ''}
            />
          )
        },
        {
          key: 'rejected',
          label: 'Rejected',
          children: (
            <PrismCode
              showClipboard
              language="xml"
              code={(await loadXml('iso2022-rejected-response')) ?? ''}
            />
          )
        }
      ];

      setTabs(newTabs);
      setIsLoading(false);
    };

    loadTabs();
  }, []);

  if (isLoading) {
    return <Skeleton active />;
  }

  return (
    <div className="flex">
      <div className="flex w-full flex-col justify-between gap-5">
        <div className="flex-row">
          <EndpointPath path="/disbursement/iso_20022" method="POST" />
        </div>
        <div className="flex flex-row flex-wrap gap-4 pr-4 lg:flex-nowrap">
          <div className="flex w-full flex-col lg:w-1/2">
            <PrismCode
              title="Request"
              dataSrc="iso2022-request"
              language="xml"
            />
          </div>

          <div className="flex w-full flex-col gap-5 lg:w-1/2">
            <div className="rounded-md bg-inpay-green-primary-mixes-20%-black text-white">
              <h2 className="p-4">Response</h2>
              <Tabs items={tabs} title="Response" style={CUSTOM_TAB_STYLE} />
            </div>

            <h2>ISO Response status codes</h2>
            <Resource
              resource={{ filePath: 'api/iso-2022-response-further-checks' }}
            />
            <Resource resource={{ filePath: 'api/iso-2022-status-codes' }} />
          </div>
        </div>
      </div>
    </div>
  );
}
